import { Button } from "antd"
import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"


const Login=()=>{
    const [creators,setCreators]=useState([{"name":"Swarnnika","email":"swarnikarajsingh@gmail.com","domain":"Swarnnika-bot", img:"https://media.licdn.com/dms/image/D5603AQE6A1ssqHKCWw/profile-displayphoto-shrink_200_200/0/1686487500917?e=1704326400&v=beta&t=3EH7Iwdqu8PZERjutyim0P7wqVKcAhjWlT860qHNGPw", _id:"1"},
    {  _id:"2","name":"Ankur","email":"ankur@gmail.com","domain":"Ankur-warikoo-bot","img":"https://images.assettype.com/fortuneindia/2017-06/a90f4e9f-a80e-4166-b9aa-bcacc9af1b5b/ankurwarikoo.jpg"},
    {  _id:"3","name":"Sadhguru","email":"sadhguru@gmail.com","domain":"sadhguru-bot",img:"https://tse4.mm.bing.net/th?id=OIP.XzHJmPgFeSZmg6HTIYPsMQHaFU&pid=Api&P=0&h=180"},
    {  _id:"4","name":"Nikis","email":"nikis@gmail.com","domain":"Nikis-bot",img:"https://www.nickiswift.com/img/gallery/famous-youtube-stars-who-sadly-died-far-too-young/intro-1589487557.jpg"}])
    const [users,setUsers]=useState([])

    const location=useLocation()

    function signin(){

        //check if email exisit for that user 

        
    }
    useEffect(()=>{
console.log(location, "location")
    },[location])
    
    
    return <div className="bg-gradient-to-b from-black via-[#4F4484] to-[#4F4484] w-screen h-screen flex items-center justify-center ">

        <div className="bg-[#fff] py-4 px-8 rounded-sm">

            <div className="flex items-center justify-center my-3">
            <input placeholder="Enter your Email"  className="border px-4 py-2"/>
                </div>
            <Button> Signin/ Signup</Button>

        </div>

    </div>
}


export default Login